import React from "react";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import update from "immutability-helper";
import isEqual from "lodash/isEqual";
import EventSource from "../../../../components/EventSourceComp/EventSourceComp";
import RFUSearch from "../components/RFUSearch";
import RFUTable from "../components/RFUTable";
import RFULegend from "../components/RFULegend";
import {
  getEMCs,
  getEMCPlantCodes,
  getEMCDockCodes,
  loadEMCs,
  loadEMCPlantCodes,
  loadEMCDockCodes
} from "../../../dashboard/duck";
import { getEnvHostname } from "../../../../shared/utils/environment";
import { INITIAL_RFU_SEARCH_FORM } from "../duck";
import { createRFUBreadcrumb } from "../../../../shared/utils/breadcrumbs";
import { getDashboardEvents } from "../../../../shared/ducks/events";
import {
  clearRFU,
  getIsFetching,
  getManifestOrderGroups,
  getMaxManifestsPerOrderGroup,
  getMaxOrderGroups,
  loadManifestOrderGroups,
  storeSearch,
  getSearchRFUForm
} from "../duck";

class RFU extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: props.searchForm,
      validations: {},
      showManifestNumber: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rfuEvents.length !== this.props.rfuEvents.length) {
      const lastEvent = this.props.rfuEvents.slice(-1);
      if (
        lastEvent &&
        lastEvent[0].type !== "rfuManifestCreated" &&
        lastEvent[0].type !== "rfuManifestUpdated"
      ) {
        // If no EMC was selected yet, do not refresh the component...
        if (this.props.searchForm && this.props.searchForm.emcCode) {
          this.handleSubmit();
        }
      }
    }
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if (nextProps.rfuEvents.length !== this.props.rfuEvents.length) {
      const nextEvent = nextProps.rfuEvents.slice(-1);
      if (
        nextEvent[0].type === "rfuManifestCreated" ||
        nextEvent[0].type === "rfuManifestUpdated"
      ) {
        return false;
      }
    }
    return true;
  };

  componentWillMount() {
    this.props.clearRFU();
    this.props.loadEMCs();

    if (
      !isEqual(INITIAL_RFU_SEARCH_FORM, this.props.searchForm) &&
      this.props.searchForm.emcCode
    ) {
      this.handleSubmit();
    }
  }

  handleChange = e => {
    const form = update(this.props.searchForm, {
      [e.target.name]: { $set: e.target.value }
    });
    this.props.storeSearch(form);
  };

  handleEmcCodeChange = e => {
    const form = update(this.props.searchForm, {
      [e.target.name]: { $set: e.target.value }
    });
    this.props.storeSearch(form);
    if (form.emcCode && form.emcCode !== "undefined") {
      this.props.loadEMCPlantCodes(form.emcCode);
    } else {
      const formUpdate = update(this.props.searchForm, {
        emcPlantCode: { $set: "" },
        emcDockCode: { $set: "" },
        emcCode: { $set: "" }
      });
      this.props.storeSearch(formUpdate);
    }
    this.props.loadEMCPlantCodes(form.emcCode);
    this.props.loadEMCDockCodes("", "");
  };

  handlePlantCodeChange = e => {
    const form = update(this.props.searchForm, {
      [e.target.name]: { $set: e.target.value }
    });
    this.props.storeSearch(form);
    if (form.emcPlantCode && form.emcPlantCode !== "undefined") {
      this.props.loadEMCDockCodes(form.emcPlantCode, form.emcCode);
    } else {
      const formUpdate = update(this.props.searchForm, {
        [e.target.name]: { $set: e.target.value },
        emcDockCode: { $set: "" }
      });
      this.props.storeSearch(formUpdate);
      this.props.loadEMCDockCodes(form.emcPlantCode, form.emcCode);
      console.log(this.props);
    }
  };

  handleDockCodeChange = name => value => {
	  /*
    console.log(value);
    let selectedValues = value.split(",");
	  let selectedValues = value;

	  if(undefined != value1 && Array.isArray(value1) && 0 < value1.length){
		  selectedValues = value1.map(function(e1){
    	  selectedValues.push(e1);
        return null;
    	})
	  } 
    console.log("Print selected values");
	  console.log(selectedValues);
    */ 
    
    const form = update(this.props.searchForm, {
      [name]: { $set: value }
  	});
    this.props.storeSearch(form);
  };

  handleSelectChange = name => value => {
	  /* 
    console.log(value);
    let selectedValues = value.split(",");
    let selectedValues = value;

	  if(undefined != value1 && Array.isArray(value1) && 0 < value1.length){
		  value1.map(function(e1){
    		selectedValues.push(e1);
        return null;
    	})
	  } 
	  console.log("Print selected values");
	  console.log(selectedValues);
    */ 
	  
    const form = update(this.props.searchForm, {
      [name]: { $set: value }
    });
    this.props.storeSearch(form);
  };
  

  handleDateChange = field => momentDate => {
    let errors = this.state.validations;
    delete errors[field];

    if (!moment(momentDate, "DD-MM-YYYY", true).isValid()) {
      errors[field] = "Please insert a valid date with format DD-MM-YYYY";
      this.setState({
        validations: errors
      });
    } else {
      this.setState({
        search: update(
          this.state.search,
          {
            [field]: { $set: momentDate }
          },
          () => {
            if (
              errors[field] !== undefined &&
              this.isValidRange(
                this.state.search.fromDate,
                this.state.search.toDate
              )
            ) {
              this.setState({
                validations: update(this.state.validations, {
                  [field]: { $set: undefined }
                })
              });
            }
          }
        )
      });
      this.props.storeSearch(
        update(this.props.searchForm, { [field]: { $set: momentDate } })
      );
    }
  };

  isValidRange = (from, to) => {
    const duration = moment.duration(moment(to).diff(moment(from)));
    return Math.abs(duration.asDays()) <= 30;
  };

  isValidToDate = currentDate => {
    return (
      currentDate.isAfter(this.state.search.fromDate) &&
      this.isValidRange(currentDate, this.state.search.fromDate)
    );
  };

  handleSubmit = () => {
    const {
      emcCode,
      fromDate,
      toDate,
      abnormalityType,
      abnormalityStatus,
      emcDockCode,
      supplierCode,
      supplierName,
      emcPlantCode
    } = this.props.searchForm;
    const formData = {
      fromDate: moment({ ...fromDate }).format("YYYY-MM-DD"),
      toDate: moment({ ...toDate }).format("YYYY-MM-DD"),
      emcCode: emcCode,
      status: abnormalityStatus,
      emcDockCode: emcDockCode
    };

    /* if (!!emcDockCode) {
      formData.emcDockCode = emcDockCode;
    }*/

    console.log(emcDockCode);
    if (!!emcDockCode) {
      if(Array.isArray(emcDockCode) && 0 == emcDockCode.length){
        formData.emcDockCode = ['']
      } else {
        formData.emcDockCode = emcDockCode.map(function(e){
          return e.value;
        });
        }
    }

    if (!!emcPlantCode) {
      formData.emcPlantCode = emcPlantCode;
    }
    if (!!supplierCode) {
      formData.supplierCode = supplierCode;
    }
    if (!!supplierName) {
      formData.supplierName = supplierName;
    }
    /*
    if (!!abnormalityType) {
      formData.abnormalityType = abnormalityType;
    }
    */
    console.log(abnormalityType);
    if (!!abnormalityType) {
      if(Array.isArray(abnormalityType) && 0 == abnormalityType.length){
        formData.abnormalityType = [''];  
      } else {
        formData.abnormalityType = abnormalityType.map(function(e){
          return e.value;
        });
        }
    }
    if (!abnormalityType) {
      formData.abnormalityType = [''];
    }
    this.props.loadManifestOrderGroups(formData);
  };

  
   handleCheckboxChange = e => {
    console.log(e.target.checked);
    this.setState({
        [e.target.name]: e.target.checked
    });
};

  render() {
    const {
      manifestOrderGroups,
      isFetching,
      maxOrderGroups,
      maxManifestsPerOrderGroup,
      emcs,
      plants,
      docks,
      searchForm
    } = this.props;
    const { validations,showManifestNumber } = this.state;

    return (
      <div>
        <EventSource url={`https://${getEnvHostname()}/api/messages/reports`} />
        {createRFUBreadcrumb()}
        <Row>
          <Col xs={12}>
            <RFUSearch
              search={searchForm}
              emcs={emcs}
              plants={plants}
              docks={docks}
              validations={validations}
              isValidToDate={this.isValidToDate}
              handleChange={this.handleChange}
              handleDateChange={this.handleDateChange}
              onSubmit={this.handleSubmit}
              handlePlantCodeChange={this.handlePlantCodeChange}
              handleDockCodeChange={this.handleDockCodeChange}
              handleEmcCodeChange={this.handleEmcCodeChange}
			  handleSelectChange={this.handleSelectChange}
        handleCheckboxChange={this.handleCheckboxChange}
        showManifestNumber={this.state.showManifestNumber}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 20 }}>
          <Col xs={12}>
            <RFULegend />
          </Col>
        </Row>
        <Row style={{ marginTop: 20 }}>
          <Col xs={12}>
            <RFUTable
              manifestOrderGroups={manifestOrderGroups}
              maxOrderGroups={maxOrderGroups}
              maxManifestsPerOrderGroup={maxManifestsPerOrderGroup}
              isFetching={isFetching}
              showManifestNumber={showManifestNumber}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  emcs: getEMCs(state),
  plants: getEMCPlantCodes(state),
  docks: getEMCDockCodes(state),
  isFetching: getIsFetching(state),
  manifestOrderGroups: getManifestOrderGroups(state),
  maxOrderGroups: getMaxOrderGroups(state),
  maxManifestsPerOrderGroup: getMaxManifestsPerOrderGroup(state),
  rfuEvents: getDashboardEvents(state),
  searchForm: getSearchRFUForm(state)
});

const mapDispatchToProps = dispatch => ({
  loadManifestOrderGroups: bindActionCreators(
    loadManifestOrderGroups,
    dispatch
  ),
  loadEMCs: bindActionCreators(loadEMCs, dispatch),
  loadEMCPlantCodes: bindActionCreators(loadEMCPlantCodes, dispatch),
  loadEMCDockCodes: bindActionCreators(loadEMCDockCodes, dispatch),
  clearRFU: bindActionCreators(clearRFU, dispatch),
  storeSearch: bindActionCreators(storeSearch, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RFU);
